import { render, staticRenderFns } from "./Pep-statements-pagination.vue?vue&type=template&id=426ee627"
import script from "./Pep-statements-pagination.vue?vue&type=script&lang=js"
export * from "./Pep-statements-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports